import * as ajax from "../../../actions/ajaxCounterActions";
import * as exception from "../../../actions/exceptionActions";

import financieelApi from "../../../api/financieelApi";

import { getStore } from "../../../store/configureStore";

export default class KostenPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		this.context.setState({
			financieelKosten: null,
			modalIsOpen: false,
			kostId: null
		});

		const dossierId = this.context.props.dossierId;
		this.getKostenByDossierId(dossierId);
	}

	loadLayout(financieel) {
		const dossierId = this.context.props.dossierId;

		this.context.props.loadLayout(financieel.naam, financieel.tabTitel, dossierId, financieel.typeDossier);
	}

	loadBeads(beadModels) {
		this.context.props.beadsLoaded(beadModels);
	}

	goToKostEdit() {
		this.redirector.goTo(`financieel/${this.context.props.dossierId}/kostedit/new`);
	}

	goToKostEditWijzig(id) {
		this.redirector.goTo(`financieel/${this.context.props.dossierId}/kostedit/${id}`);
	}

	getKostenByDossierId(dossierId) {
		this.dispatch(ajax.started());
		financieelApi.getKostenByDossierId(dossierId)
			.then(response => {
				this.dispatch(ajax.ended());
				this.setStateAfterUpdate(response.data);
				this.loadBeads(response.data.beadModels);
				this.loadLayout(response.data);
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	isReadyToRender() {
		if (!this.context.state.financieelKosten) {
			return false;
		}

		if (this.context.props.okiTypes.length < 1) {
			return false;
		}

		return true;
	}

	setStateAfterUpdate(item) {
		this.context.setState({
			financieelKosten: item
		});
	}

	deleteOpbrengstKostInvestering() {
		this.closeModal();
		this.dispatch(ajax.started());
		const state = this.context.state;
		const id = state.kostId;
		financieelApi.deleteOpbrengstKostInvestering(id)
			.then(response => {
				let kosten = state.financieelKosten.opbrengstKostInvesteringen;
				let newKosten = Object.assign({},
					state.financieelKosten,
					{
						opbrengstKostInvesteringen: kosten.filter(k => k.id !== id)
					});
				this.dispatch(ajax.ended());
				this.setStateAfterUpdate(newKosten);
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	closeModal() {
		this.context.setState({
			modalIsOpen: false
		});
	}

	openModal(id) {
		this.context.setState({
			modalIsOpen: true,
			kostId: id
		});
	}
}